/**
 * OnboardingProgress Component
 * 
 * Progress dots indicator for the onboarding carousel.
 */

import React from "react";
import { View } from "react-native";
import Animated, {
  useAnimatedStyle,
  interpolate,
  Extrapolation,
} from "react-native-reanimated";

interface OnboardingProgressProps {
  /** Total number of slides */
  total: number;
  /** Current slide index */
  current: number;
  /** Active dot color */
  activeColor?: string;
  /** Inactive dot color */
  inactiveColor?: string;
}

/**
 * Progress dots indicator
 */
export const OnboardingProgress: React.FC<OnboardingProgressProps> = ({
  total,
  current,
  activeColor = "#7C3AED",
  inactiveColor = "#E5E7EB",
}) => {
  return (
    <View className="flex-row justify-center items-center py-4">
      {Array.from({ length: total }).map((_, index) => {
        const isActive = index === current;
        
        return (
          <View
            key={index}
            className="mx-1 rounded-full"
            style={{
              width: isActive ? 24 : 8,
              height: 8,
              backgroundColor: isActive ? activeColor : inactiveColor,
            }}
          />
        );
      })}
    </View>
  );
};

export default OnboardingProgress;

